import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountMetadataQueryKey } from "../account.keys";

export const useAdminFetchAccountMetadata = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, isFetching, refetch } = useQuery({
		queryKey: accountMetadataQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.Admin.SuretyAccount.Metadata.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/metadata`,
			),
		retry: false,
	});

	return {
		metadata: data,
		metadataError: error,
		metadataIsLoading: isLoading,
		metadataIsFetching: isFetching,
		refetchMetadata: refetch,
	};
};
